import React, { useContext } from 'react';
import ChatLoginModal from '@components/chat/modals/chatLoginModal';
import ChatReportModal from '@components/chat/modals/chatReportModal';
import { ChatContext, ChatContextType } from '@components/chat/ChatContext';
import { ChatModalEnum } from '@components/chat/hooks/useChatModals';

const ChatModals = () => {
  const { chatModalType, getIsModalOpen, closeModal, reportTargetMessage } = useContext<ChatContextType>(ChatContext);

  if (!chatModalType) return null;

  return (
    <>
      <ChatLoginModal visible={getIsModalOpen(ChatModalEnum.LOGIN)} onClose={closeModal} />
      <ChatReportModal
        message={reportTargetMessage}
        visible={getIsModalOpen(ChatModalEnum.REPORT)}
        onClose={closeModal}
      />
    </>
  );
};

export default ChatModals;
